// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Prompt from './plugins/prompt/index'

Vue.config.productionTip = false
Vue.use(Prompt)

/* eslint-disable no-new */
let currVue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

export default currVue



// WEBPACK FOOTER //
// ./src/main.js